import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { TypeSelect } from "../components/Selects";
import { DateTimeInput } from "../components/Inputs";

import SearchIcon from "@mui/icons-material/Search";
import { ReferenceSelectForm } from "./ReferenceSelectForm";
import { ReferenceDateSelectForm } from "./ReferenceDateSelectForm";

export function EditOffsetForm({
  isOpen,
  onClose,
  user,
  employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
  employeePersonalInformationId, setEmployeePersonalInformationId,
  referenceDate, setReferenceDate,
  date, setDate,
  hours, setHours,
  type, setType,
  referenceId, setReferenceId,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  days, setDays,
  reason, setReason,
  files, setFiles,
  handleUpdate,
  viewImage,
}) {
  const [reference, setReference] = useState(null);
  const [showReferenceForm, setShowReferenceForm] = useState(false);
  const openReferenceForm = () => {
    setShowReferenceForm(true);
  };
  const closeReferenceForm = () => {
    setShowReferenceForm(false);
  };
  const [showReferenceDateForm, setShowReferenceDateForm] = useState(false);
  const openReferenceDateForm = () => {
    setShowReferenceDateForm(true);
  };
  const closeReferenceDateForm = () => {
    setShowReferenceDateForm(false);
  };

  const handleClose = () => {
    onClose();
    closeReferenceForm()
    closeReferenceDateForm()
    setReference(null)
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee Id</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      type="number"
                      id="employeePersonalInformationId"
                      placeholder="Employee Id"
                      value={employeePersonalInformationId}
                      onChange={(e) =>
                        setEmployeePersonalInformationId(e.target.value)
                      }
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Type</div>
                <div className="info-item-input">
                  <TypeSelect data={type} setData={setType} isView={false} />
                </div>
              </div>
              {type === "Overtime" &&
                <>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Reference Date</div>
                      <div className="info-item-input">
                        <div
                          className="info-item-holder employee-select row"
                          style={{
                            flexDirection: "row",
                            justifyContent: "normal",
                          }}
                        >
                          <input
                            readOnly
                            className="employeeInput-select"
                            placeholder="Reference"
                            value={referenceDate ? referenceDate.split("T")[0] : ""}
                          />
                          <button
                            className="select row"
                            onClick={openReferenceDateForm}
                          >
                            <SearchIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Date (To Use)</div>
                      <div className="info-item-input">
                        <DateTimeInput date={date} setDate={setDate} isView={false} />
                      </div>
                    </div>
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Hours</div>
                      <div className="info-item-input">
                        <input
                          type="number"
                          id="hours"
                          placeholder="Hours"
                          value={hours}
                          onChange={(e) => setHours(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </>}
              {type === "Leave" &&
                <>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Reference</div>
                      <div className="info-item-input">
                        <div
                          className="info-item-holder employee-select row"
                          style={{
                            flexDirection: "row",
                            justifyContent: "normal",
                          }}
                        >
                          <input
                            readOnly
                            className="employeeInput-select"
                            placeholder="Reference"
                            value={
                              referenceId
                                ? `OS-${referenceId
                                  ?.toString()
                                  .padStart(6, "0")}`
                                : ""}
                          />
                          <button
                            className="select row"
                            onClick={openReferenceForm}
                          >
                            <SearchIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Days</div>
                      <div className="info-item-input">
                        <input
                          type="number"
                          id="days"
                          placeholder="Days"
                          value={days}
                          onChange={(e) => setDays(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Date From (To Use)</div>
                      <div className="info-item-input">
                        <DateTimeInput date={dateFrom} setDate={setDateFrom} isView={false} />
                      </div>
                    </div>
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Date To (To Use)</div>
                      <div className="info-item-input">
                        <DateTimeInput date={dateTo} setDate={setDateTo} isView={false} />
                      </div>
                    </div>
                  </div>
                </>}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <ReferenceSelectForm
        isOpen={showReferenceForm}
        onClose={closeReferenceForm}
        reference={reference} setReference={setReference}
        referenceId={referenceId} setReferenceId={setReferenceId}
        setDays={setDays}
        user={user}
      ></ReferenceSelectForm>
      <ReferenceDateSelectForm
        isOpen={showReferenceDateForm}
        onClose={closeReferenceDateForm}
        reference={referenceDate} setReference={setReferenceDate}
        setHours={setHours}
        user={user}
      ></ReferenceDateSelectForm>
    </>
  );
}